import React from "react"

import LoanPayoff from "activities/calculators/early-payoff"
import merge from "lodash/merge"

export default (props) => (
  <LoanPayoff
    {...merge(
      {
        id: "personal-loan",
        title: "Personal Loan Calculator",
        subtitle: "This calculator will help you determine the monthly payments on a personal loan.",
        amountTitle: "Loan Amount",
        loanTerm: {
          min: 1,
          max: 30,
          step: 1
        },
        interestRate: {
          min: 0,
          max: 20,
          step: 0.05
        },
        addedPayment: {
          min: 0,
          max: (payment) => Math.floor((payment * 5) / 100) * 100,
          step: 50
        },
        initialState: {
          price: 10000,
          term: 10,
          rate: 8,
          additionalPayment: 50
        },
        ariaLabel:
          "This line graph visually represents how much sooner you could pay off your loan. Read below to find the monthly payment, interest saved, interest to be paid, and the date the loan will be paid off."
      },
      props
    )}
  />
)
